var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"nav-link"},[_vm._v(_vm._s(_vm.dimension.nombre))])}
var staticRenderFns = []

export { render, staticRenderFns }